import { render, staticRenderFns } from "./checkbox_captcha.vue?vue&type=template&id=541fa1a3&scoped=true&"
import script from "./checkbox_captcha.vue?vue&type=script&lang=js&"
export * from "./checkbox_captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541fa1a3",
  null
  
)

export default component.exports